import { Routes, Route, Navigate } from 'react-router-dom'
import Header from './components/Header'
import VideosScreen from './screens/VideosScreen'
import NotFoundScreen from './screens/NotFoundScreen'
import StandalonePlayerScreen from './screens/StandalonePlayerScreen'
import AsidePlayer from './components/AsidePlayer'
import GlobalStyle from './styled/GlobalStyle'
import QuestionModal from './components/QuestionModal'
import YoutubeAPIContext from './components/YoutubeQuestioner/context'
import { useState } from 'react'

const playerInitial = { loaded: false, api: null }
function App() {
  const [player, setPlayer] = useState(playerInitial)
  const resetPlayer = () => {
    if (player.loaded) {
      setPlayer(playerInitial)
    }
  }

  return (
    <YoutubeAPIContext.Provider value={{ setPlayer, player, resetPlayer }}>
      <GlobalStyle />
      <QuestionModal />
      <Header />
      <Routes>
        <Route path="/" element={<Navigate to="/videos" />} />
        <Route path="/videos" element={<VideosScreen />}>
          <Route path=":id" element={<AsidePlayer />} />
        </Route>
        <Route path="/video/:id" element={<StandalonePlayerScreen />} />
        <Route path="*" element={<NotFoundScreen />} />
      </Routes>
    </YoutubeAPIContext.Provider>
  )
}

export default App
